import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
// import { HttpClientService } from '../http-client';
import { map } from 'rxjs/operators'
import { HttpClientService } from 'src/app/core/http/http-client';
import { Store } from 'src/app/core/store/store';

@Injectable({
  providedIn: 'root'
})
export class PlayerUtilityService {
  private showbackButton = new Subject<boolean>()
  public showbackButton$ = this.showbackButton.asObservable()
  private destroyComponent = new Subject<boolean>()
  public destroyComponent$ = this.destroyComponent.asObservable();
  private seekToTime = new Subject<boolean>()
  public seekToTime$ = this.seekToTime.asObservable();
  private videoNotes = new Subject<any>()
  public videoNotes$ = this.videoNotes.asObservable();


  private inVideoAnswers = new Subject<any[]>()
  public inVideoAnswers$ = this.inVideoAnswers.asObservable();
  videoDetail: any;

  constructor(private http: HttpClientService, private store: Store) { }

  set isBackRequired(val) {
    this.showbackButton.next(val)
  }

  set setInVideoAnswers(val) {
    this.inVideoAnswers.next(val);
  }
  set destroyResultComponent(val) {
    this.destroyComponent.next(val)
  }

  set setSeekToTime(val){
    this.seekToTime.next(val)
  }

  set setvideoNotes(val){
    this.videoNotes.next(val)
  }

  submitVideoQuestionCardAnswer(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('contents/submit/videoquestioncardanswer', obj).pipe(map(res => {
      console.log(res);
      return res.data;
    }
    ));;
  }

  submitPostQuestion(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  updatePostQuestion(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/update', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  deleteComment(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/removeComment', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  updatePostComment(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/updateComment', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  flagPost(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/flagPost', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  unFlagPost(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/unFlagPost', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  likePost(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/likePost', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  commentPost(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/addComment', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  unlikePost(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/unlikePost', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }


  getPostQuestions(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('post/getAllPosts', obj).pipe(map(res => {
      return res.data;
    }
    ));;
  }

  getVideoQuestionResponseByUserAndCourse(courseId, questionCardId, programActivationId?) {
    return this.http.get<{ data: any, result: number, msg: string }>(`contents/videoquestionresponse/${courseId}?questionCardId=${questionCardId}&programActivationId=${programActivationId}`).pipe(map(res => {
      return res.data;
    }
    ));
  }
  getAllVideoQuestionResponseByUserAndCourse(courseId,contentId) {
    return this.http.get<{ data: any, result: number, msg: string }>(`contents/videoquestionresponse/${courseId}?contentId=${contentId}`).pipe(map(res => {
      return res.data;
    }
    ));
  }

  getFeedbackResponseByUserAndCourse(courseId, likeDislikeCardId) {
    return this.http.get<{ data: any, result: number, msg: string }>(`contents/videoquestionresponse/${courseId}?likeDislikeCardId=${likeDislikeCardId}`).pipe(map(res => {
      return res.data;
    }
    ));
  }

  saveFeedback(obj) {
    return this.http.post<{ data: any, result: number, msg: string }>('ipj/user-progress/course-feedback', obj).pipe(map(res => {
      this.store.set('currentUserCourse', res.data)
      return res.data;
    }
    ));
  }

  // capture events related to stride
  setVideoDetail (data) {
    this.videoDetail = data;
  }
  
  // capture events related to stride
  getVideoDetail () {
    return this.videoDetail;
  }

}
